export enum FleetChangeHandling {
    RECORDED_ONLY = 'RECORDED_ONLY',
    MIRROR_VESSEL = 'MIRROR_VESSEL',
    ESTIMATE_FULL_PERIOD = 'ESTIMATE_FULL_PERIOD',
    EXCLUDE = 'EXCLUDE',
    INCLUDE = 'INCLUDE',
}
